import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import Box from 'src/components/Box/Box'
import SpendGraph, {
  SpendGraphData,
} from 'src/components/SpendGraph/SpendGraph'
import Crncy, { useCurrencyFormatter } from 'src/localization/Crncy'
import { dateFormatString } from 'src/localization/Dte'
import { translateSingleString, useTranslate } from 'src/localization/Trns'
import { CreditCardListModel } from 'src/models/creditCard.models'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { toDollars } from 'src/utils/currency.utils'
import { css } from 'styled-components'

interface AccountMetricsSummaryBoxProps {
  className?: string
  creditCard: CreditCardListModel
  graphData: SpendGraphData[]
  totalSpent?: number
  isLoading: boolean
}

const AccountMetricsSummaryBox: React.FC<AccountMetricsSummaryBoxProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  const locale = useSelector(selectNullSafeLocaleFromState)
  const currencyFormatter = useCurrencyFormatter()

  return (
    <Box
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      {!props.isLoading && (
        <Fragment>
          <div
            css={css`
              display: flex;
              align-items: center;
              margin-bottom: 30px;
            `}
          >
            <span
              css={css`
                ${getFontCss(
                  20,
                  themeConstants.colors.font_primary,
                  styleConstants.fontFamilies.medium,
                )};
              `}
            >
              {translate('Spend')}
            </span>
            {props.totalSpent !== undefined && (
              <span
                css={css`
                  ${getFontCss(
                    20,
                    themeConstants.colors.highlight,
                    styleConstants.fontFamilies.regular,
                  )};
                  margin-left: 20px;
                  white-space: nowrap;
                `}
              >
                {translate('${amount} in last 30 days', {
                  amount: (
                    <Crncy
                      currency={props.creditCard.currency}
                      amount={toDollars(props.totalSpent)}
                    />
                  ),
                })}
              </span>
            )}
          </div>
          <SpendGraph
            graphData={props.graphData}
            currency={props.creditCard.currency}
            xAxisProps={{
              ticks: false,
              label:
                props.graphData[0] !== undefined &&
                props.graphData[props.graphData.length - 1] !== undefined
                  ? translateSingleString(locale, '${startDate} - ${endDate}', {
                      startDate: dateFormatString(props.graphData[0].x, 'l'),
                      endDate: dateFormatString(
                        props.graphData[props.graphData.length - 1].x,
                        'l',
                      ),
                    })
                  : undefined,
            }}
            yAxisProps={{
              tickFormatter: (val: number): string =>
                currencyFormatter({
                  amount: val,
                  currency: props.creditCard.currency,
                  notation: 'compact',
                }),
            }}
          />
        </Fragment>
      )}
    </Box>
  )
}

export default AccountMetricsSummaryBox
